<div class="wrapper-global" [ngStyle]="{'justify-content': details ? 'flex-start' : 'center'}">
  <div class="wrapper-img">
    <img [src]="'../../../assets/' + img" [alt]="text | transloco" [title]="text | transloco">
  </div>
  <p>{{text | transloco}}</p>
  <div class="cart-infos">
    <ul class="list">
      <li *ngFor="let elem of details; let last = last;">
        <img [src]="'../../../assets/icons/' + elem.img" [title]="elem.text | transloco" [alt]="elem.text | transloco">
        {{elem.text | transloco}}<span *ngIf="!last else notLast">;</span>
        <ng-template #notLast>.</ng-template>
      </li>
    </ul>
    <p class="bottom-text">{{description | transloco}}</p>
  </div>
</div>